import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from "./c005-bookingform-common";
require('parsley');

export class partnerForm {
	private formEl:any = $('#agreement_form');
	private $loginError:Array<string> = [];
	$validationSuccess    : any = true;
	$scope: any = $('#agreement_form');
	private contactBase:any = new contactForm();$error:Array<any>;
	private bookingformcommon = new bookingFormCommon();

	initRecaptcha():any {

		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'partners-form-registration-recaptcha',
			cb: 'recaptchaCorporateSuccess',
			cbObj:	function () {
								(document.getElementById('partners-form-registration-recaptcha') as HTMLInputElement).value = 'true';
							if($("input[name=companyname]").val()!="" && $("input[name=companyregno]").val()!="" && $("input[name=companyadd]").val()!="" && $("input[name=adminEmail]").val()!=""&& grecaptcha && grecaptcha.getResponse().length > 0)
							{
								if($(".ridge").hasClass("scrolled"))
								{
									$('#agree').css({ 'opacity': '1.0','pointer-events': 'auto' });
								}else{
									$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
								}		
							} 
							else
							{
								$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
							}
							},
			displayId: 'partners-registration--grecaptcha',
			formEl: _self.formEl
		};
		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

	partnerForm(): any {
		let _self = this;
		// $("#emial  :input").change(function(evt:any) {
		// 	var re = /([A-Z0-9a-z_-][^@])+?@[^$#<>?]+?\.[\w]{2,4}/.test(this.value);
		// 	if(!re) {
		// 		$('#error').show();
		// 		alert("asdsa")
		// 	} else {
		// 		$('#error').hide();
		// 		alert("dsadas")
		// 	}
		// });
		$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
		$("#agreement_form  :input").change(function(evt:any) {
			if($(this)[0].id=="partner-agreement--adminEmail")
			{
				var re = /([A-Z0-9a-z_-][^@])+?@[^$#<>?]+?\.[\w]{2,4}/.test(this.value);
				if(!re) {
					$('#emailerror').show();
					$("input[name=adminEmail]").val("");
				} else {
					$('#emailerror').hide();
					//$(".errorMsg").hide();
				}
			}
		if($(".ridge").hasClass("scrolled"))
		{
			if($("input[name=companyname]").val()!="" && $("input[name=companyregno]").val()!="" && $("input[name=companyadd]").val()!="" && $("input[name=adminEmail]").val()!=""&& grecaptcha && grecaptcha.getResponse().length > 0)
			{
				$('#agree').css({ 'opacity': '1.0','pointer-events': 'auto' });
			} 
			else
			{
				$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
			}
		}
		else{
				$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
		}
		});	
  
		$('.ridge').on('scroll', function() {
			let isvalid:any=false;
			if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) 
			{
				isvalid=true;
				$(".ridge").addClass("scrolled")
			}
			if($("input[name=companyname]").val()!="" && isvalid && $("input[name=companyregno]").val()!=""&& $("input[name=companyadd]").val()!="" && $("input[name=adminEmail]").val()!="" && grecaptcha && grecaptcha.getResponse().length > 0)
			{

				$('#agree').css({ 'opacity': '1','pointer-events': 'auto' });
			} 
		})
		$('#agreement_form').on('keyup', function(e:any) 
		{
			if($(".ridge").hasClass("scrolled"))
		{
			if($("input[name=companyname]").val()!="" && $("input[name=companyregno]").val()!="" && $("input[name=companyadd]").val()!="" && $("input[name=adminEmail]").val()!=""&& grecaptcha && grecaptcha.getResponse().length > 0)
			{
				$('#agree').css({ 'opacity': '1.0','pointer-events': 'auto' });
			} 
			else
			{
				$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
			}
		}
		else{
				$('#agree').css({ 'opacity': '0.5','pointer-events': 'none' });
		}	
		});
	}
	initSubmitAgreemrnt(): any {
		let defer = $.Deferred();
		let _self = this;
		$("#btn-member--submit").click(function() {
			//alert("submit");		
			let companyname=$("input[name=companyname]").val();
			let companyregno=$("input[name=companyregno]").val();
			let companyadd=$("input[name=companyadd]").val();
			let adminEmail=$("input[name=adminEmail]").val();
			
			if(companyname!="" && companyregno!="" && companyadd!="" && adminEmail!="")
			{
				var data = {
					'companyname':	companyname,
					'companyregno': companyregno,
					'companyadd':companyadd,
					'adminEmail':adminEmail,
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/parnerportalAgreemrntFormEmail',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						}	else {
							json = data;
						}
						_self.bookingformcommon.preloaderClose();
						if(json.processCode=="OK")
						{
							$(".successMsg").show();
							$(".errorMsg").hide();
							$("#agreement_form").hide();
							$("#agreement_conditions").hide();
							$("#agreement_recapture").hide();
							$("#agreementDesc").hide();
							
						}else{
							$(".errorMsg").show();
							$(".successMsg").hide();
							$("#agreement_form").hide();
							$("#agreement_conditions").hide();
							$("#agreement_recapture").hide();
							$("#agreementDesc").hide();
						}
					}, error: function(error: any) {
						defer.reject(error);
						_self.bookingformcommon.preloaderClose();
					}
				});
			}
			else{
				if(companyname==""){
					$('#compNamererror').show();
				}else{
					$('#compNamererror').hide();
				}
				if(companyregno==""){
					$('#compRegrerror').show();
				}else{
					$('#compRegrerror').hide();
				}
				if(companyadd==""){
					$('#compAddrerror').show();
				}else{
					$('#compAddrerror').hide();
				}
				if(adminEmail==""){
					$('#emailInputerror').show();
					$('#emailerror').hide();
				}else{
					$('#emailInputerror').hide();
					$('#emailerror').hide();
				}
			
			}
		});
	}
}

let scope:Element = document.querySelector('#agreement_form');
if (scope){
	try {
	let partnerform = new partnerForm();
		partnerform.initRecaptcha();
		partnerform.partnerForm();
		partnerform.initSubmitAgreemrnt();			
	} catch(e) {console.error(e);}
}